import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { createNumberMask } from "text-mask-addons";
import SelectSearchBootstrap from "../../../components/InputSelectSearch/SelectSearchBootstrap";
import { formatDB } from "../../../components/Utils/Currency";
import MaskedInput from "react-text-mask";
import { useMutation } from "react-query";
import TransactionDeliveryService from "../../../Services/TransactionDelivery";
import { handleError } from "../../../components/Utils/Utils";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";

const FormStartDelivery = (props) => {
  const { delivery, isShow, onClose, refetch } = props;
  const property = delivery?.property || "";
  const delivery_group = delivery?.delivery_groups
    ? delivery?.delivery_groups[0] || ""
    : "";
  const delivery_package = delivery_group?.delivery_package || "";
  const transaction = delivery?.transaction || "";
  const orders = delivery_group?.orders || "";

  const deliveryAgents = [
    {
      value: "JNE",
      name: "JNE",
    },
    {
      value: "J&T",
      name: "J&T",
    },
    {
      value: "TIKI",
      name: "TIKI",
    },
    {
      value: "POS INDONESIA",
      name: "POS INDONESIA",
    },
    {
      value: "PAXEL",
      name: "PAXEL",
    },
    {
      value: "ANTER AJA",
      name: "ANTER AJA",
    },
    {
      value: "SICEPAT",
      name: "SICEPAT",
    },
    {
      value: "GRAB",
      name: "GRAB",
    },
    {
      value: "GO-JEK",
      name: "GO-JEK",
    },
    {
      value: "ID EXPRESS",
      name: "ID EXPRESS",
    },
    {
      value: "OTHERS",
      name: "OTHERS",
    },
  ];

  const numberMask = (allowDecimal) => {
    return createNumberMask({
      prefix: "",
      sufix: "",
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ".",
      allowDecimal: allowDecimal,
      decimalSymbol: ",",
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });

  const watchFields = watch();

  const mutationPostManualNotify = useMutation(TransactionDeliveryService.postManualNotify, {
    onError: (error, variables) => {
      handleError(error);
    },
    onSuccess: (data, variables) => {
      notifUtils("Success Update Delivery State", "success")
      refetch();
      onClose();
    }
  })

  const onSubmit = (data) => {
    data.delivery_st = "IN_DELIVERY"
    if(data?.estimate_fee) {
      data.estimate_fee = parseFloat(formatDB(data.estimate_fee))
    }
    mutationPostManualNotify.mutate(data)
  };

  React.useEffect(() => {
    reset({})
    if (delivery_group !== "") {
      setValue("delivery_id", delivery_group?.delivery_id)
      setValue("delivery_courier", {
        name: "",
        phone: "",
        vehicle: ""
      })
      if (!delivery_package?.is_cod) {
        setValue("delivery_agent", delivery_package?.vendor?.name);
        setValue("delivery_ref_no", "");
        setValue("tracking_url", "");
      } else {
        setValue("delivery_agent", "");
      }
    }
  }, [delivery_group]);

  return (
    <Modal
      isOpen={isShow}
      toggle={onClose}
      backdrop={false}
      size="lg"
      centered={true}
      zIndex={1300}
      modalClassName="modal-custom"
    >
      <ModalHeader toggle={onClose}>Start Delivery</ModalHeader>
      <ModalBody>
        <form id="hook-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-4">
            {delivery_package !== "" && delivery_package?.is_cod === true && (
              <div className="row">
                <div className="col-md-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="delivery_agent"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Delivery Agent</span>
                    </label>
                    <Controller
                      name="delivery_agent"
                      control={control}
                      render={({ field }) => (
                        <SelectSearchBootstrap
                          {...field}
                          options={deliveryAgents}
                          search
                          closeOnSelect={true}
                          placeholder="Search delivery agent"
                          value={
                            watchFields["delivery_agent"]
                              ? watchFields["delivery_agent"]
                              : ""
                          }
                        />
                      )}
                      rules={{
                        required: "Please select delivery agent",
                      }}
                      defaultValue={watchFields["delivery_agent"] || ""}
                    />
                    {errors.delivery_agent && (
                      <small className="form-text text-error">
                        {errors?.delivery_agent?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="delivery_ref_no"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Delivery Number</span>
                      <span className="font-bold text-muted">
                        {watchFields["delivery_ref_no"]?.length || 0} / 100
                      </span>
                    </label>
                    <input
                      type="text"
                      id="delivery_ref_no"
                      name="delivery_ref_no"
                      className="form-control rounded-8px"
                      {...register("delivery_ref_no", {
                        required: "Please input delivery number",
                        maxLength: {
                          value: 100,
                          message: "Maximum character 100",
                        },
                      })}
                    />
                    {errors.delivery_ref_no && (
                      <small className="form-text text-error">
                        {errors?.delivery_ref_no?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="tracking_url"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Delivery Tracking URL</span>
                      <span className="font-bold text-muted">
                        {watchFields["tracking_url"]?.length || 0} / 250
                      </span>
                    </label>
                    <input
                      type="text"
                      id="tracking_url"
                      name="tracking_url"
                      className="form-control rounded-8px"
                      {...register("tracking_url", {
                        maxLength: {
                          value: 250,
                          message: "Maximum character 250",
                        },
                      })}
                    />
                    {errors.tracking_url && (
                      <small className="form-text text-error">
                        {errors?.tracking_url?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="estimate_fee"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Estimate Fee</span>
                    </label>
                    <Controller
                      render={({ field }) => (
                        <MaskedInput
                          {...field}
                          mask={numberMask(false)}
                          className="form-control rounded-8px"
                        />
                      )}
                      name="estimate_fee"
                      control={control}
                      rules={{
                        required: "Please input estimate fee",
                        validate: (estimate_fee) => {
                          if (parseFloat(formatDB(estimate_fee || 0)) < 0) {
                            return "Estimate Fee min 0";
                          }
                          return true;
                        },
                      }}
                      defaultValue={0}
                    />
                    {errors.estimate_fee && (
                      <small className="form-text text-error">
                        {errors?.estimate_fee?.message}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12">
                <label className="font-12 font-bold d-flex justify-content-between align-items-center">
                  <span>Courier/Driver</span>
                </label>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group mb-4">
                  <label
                    htmlFor="delivery_courier-name"
                    className="font-12 font-bold d-flex justify-content-between align-items-center"
                  >
                    <span>Name</span>
                    <span className="font-bold text-muted">
                      {watchFields["delivery_courier"] ? watchFields["delivery_courier"]["name"]?.length || 0 : 0} / 100
                    </span>
                  </label>
                  {delivery_package !== "" && delivery_package?.is_cod && (
                    <input
                      type="text"
                      id="delivery_courier-name"
                      name="delivery_courier.name"
                      className="form-control rounded-8px"
                      {...register("delivery_courier.name", {
                        maxLength: {
                          value: 100,
                          message: "Maximum character 100",
                        },
                      })}
                    />
                  )}
                  {delivery_package !== "" &&
                    delivery_package?.is_cod === false && (
                      <input
                        type="text"
                        id="delivery_courier-name"
                        name="delivery_courier.name"
                        className="form-control rounded-8px"
                        {...register("delivery_courier.name", {
                          required: "Please input courier/driver name",
                          maxLength: {
                            value: 100,
                            message: "Maximum character 100",
                          },
                        })}
                      />
                    )}
                  {errors?.delivery_courier &&
                    errors?.delivery_courier?.name && (
                      <small className="form-text text-error">
                        {errors?.delivery_courier?.name?.message}
                      </small>
                    )}
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group mb-4">
                  <label
                    htmlFor="delivery_courier-vehicle"
                    className="font-12 font-bold d-flex justify-content-between align-items-center"
                  >
                    <span>License Plate</span>
                    <span className="font-bold text-muted">
                    {watchFields["delivery_courier"] ? watchFields["delivery_courier"]["vehicle"]?.length || 0 : 0} /
                      15
                    </span>
                  </label>
                  <input
                    type="text"
                    id="delivery_courier-vehicle"
                    name="delivery_courier.vehicle"
                    className="form-control rounded-8px"
                    {...register("delivery_courier.vehicle", {
                      maxLength: {
                        value: 15,
                        message: "Maximum character 15",
                      },
                    })}
                  />
                  {errors?.delivery_courier &&
                    errors?.delivery_courier?.vehicle && (
                      <small className="form-text text-error">
                        {errors?.delivery_courier?.vehicle?.message}
                      </small>
                    )}
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group mb-4">
                  <label
                    htmlFor="delivery_courier-phone"
                    className="font-12 font-bold d-flex justify-content-between align-items-center"
                  >
                    <span>Phone Number</span>
                    <span className="font-bold text-muted">
                    {watchFields["delivery_courier"] ? watchFields["delivery_courier"]["phone"]?.length || 0 : 0} / 20
                    </span>
                  </label>
                  {delivery_package !== "" && delivery_package?.is_cod && (
                    <input
                      type="text"
                      id="delivery_courier-phone"
                      name="delivery_courier.phone"
                      className="form-control rounded-8px"
                      {...register("delivery_courier.phone", {
                        maxLength: {
                          value: 20,
                          message: "Maximum character 20",
                        },
                      })}
                    />
                  )}
                  {delivery_package !== "" &&
                    delivery_package?.is_cod === false && (
                      <input
                        type="text"
                        id="delivery_courier-phone"
                        name="delivery_courier.phone"
                        className="form-control rounded-8px"
                        {...register("delivery_courier.phone", {
                          required: "Please input courier/driver phone number",
                          maxLength: {
                            value: 20,
                            message: "Maximum character 20",
                          },
                        })}
                      />
                    )}
                  {errors?.delivery_courier &&
                    errors?.delivery_courier?.phone && (
                      <small className="form-text text-error">
                        {errors?.delivery_courier?.phone?.message}
                      </small>
                    )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <div className="d-block form-group text-right">
          <button
            type="button"
            className="btn btn-default border-0 mr-3"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="hook-form"
            className="btn btn-blue border-0"
          >
            Start
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default FormStartDelivery;
